import Ar from './ar'
import De from './de'
import enUS from './en-US'
import Fr from './fr'
import It from './it'
import Ja from './ja'
import Pt from './pt'
import Ru from './ru'
import Sp from './sp'
import zhHans from './zh-hans'
import zhHant from './zh-hant'

export default {
  ar: Ar,
  de: De,
  'en-US': enUS,
  fr: Fr,
  it: It,
  ja: Ja,
  pt: Pt,
  ru: Ru,
  sp: Sp,
  'zh-hans': zhHans,
  'zh-hant': zhHant
}
